<template>
  <b-modal
    id="modal-pinned-worksModal"
    :title="$t('pin_the_type_of_work_to_brigade')"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    size="xl"
    centered
    no-close-on-backdrop
    @ok="onSubmitWarehouseId"
  >
    <b-form>
      <b-row>
        <b-col class="col-md-2">
          <AppSearchInput
            :label="$t('namee')"
            :placeholder="$t('namee')"
            @callback="search"
          />
        </b-col>
        <b-col></b-col>
        <b-col class="col-md-2 d-flex justify-content-end h-100">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-add-works
            style="margin-top: 18px"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" size="16" />
            {{ $t("add") }}
          </b-button>
        </b-col>
      </b-row>
      
      <b-table
        :fields="fields"
        :items="GET_ALL_BRIGADE_WORKS.results"
        show-empty
        hover
        responsive
        :empty-text="$t('empty_text')"
        :sticky-header="stickyHeader"
        :no-border-collapse="noCollapse"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(title)="props">
          <span>{{ props.item.title }}</span>
        </template>


        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-checkbox
              v-model="props.item.actions"
              class="mr-1"
              @input="selectionChange($event, props.item.id)"
            />

            <div class="d-flex align-items-center justify-content-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.modal-add-brigade
                size="sm"
                variant="warning"
                @click="editTableRow(props.item)"
              >
                <feather-icon icon="EditIcon" size="15" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                class="ml-1"
                variant="danger"
                @click="handleDelete(props)"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
            </div>

          </div>
        </template>
      </b-table>

  
      <!-- <Pagination
        :nobody="false"
        :rows="GET_ALL_BRIGADE_WORKS.count"
        :params="filter"
        @refresh="refresh()"
      /> -->
    </b-form>

    <addWorksModal></addWorksModal>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormCheckbox,
  BTable,
  BRow,
  BCol,
  BBadge,
  BButton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import addWorksModal from './addWorksModal.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    BModal,
    BForm,
    BFormCheckbox,
    BTable,
    BRow,
    BCol,
    BBadge,
    BButton,
    AppSearchInput,
    addWorksModal,
    Pagination,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    object: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      selected_rows: [],
      nobody: true,
      stickyHeader: true,
      noCollapse: true,
      filter: {
        search: null,
        page: 1,
        page_size: 1000
      },
      // ===============  PRIMARY_DATA_SECTION END ===============





      // ===============  OTHERS_SECTION START ===============
      fields: [
        {
          label: 'ID',
          key: 'id',
        },
        {
          label: 'general.title',
          key: 'title',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'unit_of_measurement',
          key: 'unity_title',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'actions',
          key: 'actions',
          tdClass: 'text-right',
          thClass: 'text-right',
        },
      ],
      // ===============  OTHERS_SECTION END ===============



      
    }
  },

  computed: {
    ...mapGetters('obectsWarehouse', ['GET_WAREHOUSE']),
    ...mapGetters('brigadeWorks', ['GET_ALL_BRIGADE_WORKS']),
  },


  async mounted(){

    await this.refresh()

  },



  methods: {
    ...mapActions('obectsWarehouse', ['FETCH_WAREHOUSE_ID', 'UPDATE_CHECKBOX', 'FETCH_WAREHOUSE_LEFT_TABLE', 'FETCH_WAREHOUSE']),
    ...mapActions('brigadeWorks', ['FETCH_ALL_BRIGADE_WORKS', 'FETCH_ONE_BRIGADE_WORKS']),
    ...mapActions('brigade', ['UPDATE_PATCH_BRIGADE', 'FETCH_ONE_BRIGADE']),



    async refresh(){
      await this.FETCH_ALL_BRIGADE_WORKS(this.filter)
    },





    editTableRow(item){
      this.$route.params.editMode = true
      this.editBrigade = item
    },




    // ===============  DELETE_SECTION START ===============
    handleDelete(props) {
      this.$_showAreYouSureModal().then(val => {
          if (val) {
            this.DELETE_BRIGADE(props.item.id)
              .then(async () => {
                await this.refresh();
                this.$_okToast()
              })
              .catch(err => {
                this.$_errToast(err)
              });
          }
        });
    },
    // ===============  DELETE_SECTION END ===============






    // ===============  OTHERS_SECTION START ===============
    selectionChange(val, id) {
      const index_id = this.selected_rows.indexOf(id)
      if (val) {
        this.selected_rows.push(id)
      } else {
        this.selected_rows.splice(index_id, 1)
      }
    },
    async search(text) {
      this.filter.search = text
      await this.refresh()
      // await this.FETCH_WAREHOUSE_ID(this.filter)
      // await this.FETCH_WAREHOUSE_LEFT_TABLE(this.filter)
    },
    // ===============  OTHERS_SECTION END ===============







    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmitWarehouseId(bvModalEvt) {
      bvModalEvt.preventDefault()

      let work_types = []
      this.selected_rows.forEach(async (e, i) => {
        work_types.push(e)
      })

      await this.UPDATE_PATCH_BRIGADE({
        id: this.$route.query.brigade_id,
        work_types: work_types
      })
        .then( async () => {
          // if (this.selected_rows.length - 1 === i) {
            await this.FETCH_ONE_BRIGADE({ id: this.$route.query.brigade_id })
            // await this.FETCH_WAREHOUSE_LEFT_TABLE({
            //   object: this.object.id,
            //   is_object: 0,
            // })
            // // await this.fetchModal()
            this.$nextTick(() => {
              this.$bvModal.hide('modal-pinned-worksModal')
            })

            this.GET_ALL_BRIGADE_WORKS.results.forEach((elem) => {
              elem.actions = false
            })
          // }
        })
    },
    // ===============  ON_SUBMIT_SECTION END ===============






    
  },
}
</script>
